import React from 'react';
import './AdBannerCard.css';

const AdBannerCard = ({ imageUrl, title, subtitle, ctaText, onCtaClick }) => {
  return (
    <div id="ad-banner" className="ad-banner-container">
      <div className="ad-banner-image-container">
        <img 
          src={imageUrl} 
          alt="Promotional Banner" 
          className="ad-banner-image" 
        />
        <div className="ad-banner-overlay"></div>
      </div>
      
      <div className="ad-banner-content">
        <h2 className="ad-banner-title">{title}</h2>
        {subtitle && <p className="ad-banner-subtitle">{subtitle}</p>}
        <button 
          className="ad-banner-cta"
          onClick={onCtaClick}
        >
          {ctaText}
        </button>
      </div>
    </div>
  );
};

export default AdBannerCard;